import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import spinLottie from "@/assets/lottie/spin.lottie?url";
import moneySvg from "@/assets/cash.svg"

export function PurchaseLoading() {
    return (
        <>
            <DotLottieReact
                src={spinLottie}
                autoplay
                loop
                style={{
                    width: "85%",
                    height: "85%",
                    objectFit: "contain",
                    transform: "translateY(5px)"
                }}
            />
            <div className="absolute pointer-events-none flex items-center justify-center translate-y-[5px]">
                <img src={moneySvg} className='h-14' alt='money'/>
            </div>
        </>
    )
}